import { SearchRequestBody } from '../../api/types';
import { BaseComponentPropsType } from '../type';

export const searchParamsToSearchFilters = (
  searchParams: URLSearchParams,
  pageContext: BaseComponentPropsType['pageContext'],
  brandId?: string | number,
) => {
  const params: Record<string, string | string[] | undefined> = {};
  searchParams.forEach((value, key) => {
    let decodedKey = decodeURIComponent(key);
    const decodedValue = decodeURIComponent(value);
    // This key is part of an array
    if (decodedKey.endsWith('[]')) {
      decodedKey = decodedKey.replace('[]', '');
      params[decodedKey] || (params[decodedKey] = []);
      (params[decodedKey] as string[]).push(decodedValue);
      // Just a regular parameter
    } else {
      params[decodedKey] = decodedValue;
    }
  });

  const searchRequest: SearchRequestBody = {
    sort: [],
  };
  if (brandId) {
    searchRequest.brandIds = [+brandId];
  } else if (pageContext?.brandId) {
    searchRequest.brandIds = [+pageContext?.brandId];
  }
  if (params.titleInclude) {
    searchRequest.titleInclude = params.titleInclude as string[];
    searchRequest.organicSearchTerm = params.titleInclude[0];
  }
  if (params.campaignTypes) {
    searchRequest.campaignTypes = (params.campaignTypes as string[]).map((id) => id);
  }
  if (params.retailerIds) {
    searchRequest.retailerIds = (params.retailerIds as string[]).map((id: string) => +id);
  }
  if (params.brandIds) {
    searchRequest.brandIds = (params.brandIds as string[]).map((id: string) => +id);
  }
  if (params.retailPrice) {
    searchRequest.retailPrice = (params.retailPrice as string[]).map((id: string) => {
      if (id === '0to25') {
        return { min: 0, max: 25 };
      }
      if (id === '25to50') {
        return { min: 25, max: 50 };
      }
      if (id === '50to100') {
        return { min: 50, max: 100 };
      }
      if (id === 'over100') {
        return { min: 100 };
      }
      return {};
    });
  }
  if (params.categoryIds) {
    searchRequest.categoryIds = (params.categoryIds as string[]).map((id) => +id);
  }
  if (params.subCategoryIds) {
    searchRequest.subCategoryIds = (params.subCategoryIds as string[]).map((id) => +id);
  }
  return searchRequest;
};
